import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { decodeHtml } from '@general/helpers/text.helpers';
import DownloadIcon from '@icons/DownloadIcon';
import ExternalLinkIcon from '@icons/ExternalLinkIcon';
import { BodyMedium, ButtonForIcon } from '@react/styledComponents';
import DocumentIcon from './DocumentIcon';
import PdfIcon from './PdfIcon';
import WebpageIcon from './WebpageIcon';

const DocumentListItem = ({ document }) => {
    const fileExtension = useMemo(
        () =>
            document.document_file
                .split('.')
                .pop()
                .toLowerCase(),
        [document.document_file]
    );

    if (!document.document_file && !document.document_url) {
        return null;
    }

    return (
        <div className="list-card py-4 my-0 w-100">
            <div className="d-flex">
                <div className="hidden md:block">
                    {fileExtension === 'pdf' && <PdfIcon />}
                    {fileExtension.length > 0 && fileExtension !== 'pdf' && <DocumentIcon />}
                    {fileExtension.length === 0 && document.document_url && <WebpageIcon />}
                </div>

                <div className="d-flex gap-4 w-100">
                    <div className="card-block p-0 md:ml-1rem">
                        <a
                            href={document.document_file || document.document_url}
                            className="card-link"
                            rel="noreferrer"
                            target="_blank"
                        >
                            <h3 className="card-title mt-1 mb-0 ml-0 mx-0 py-0 display8 bold d7-truncate2 truncate-lines inline-block">
                                {document.document_title}
                            </h3>
                        </a>

                        {document.document_description && (
                            <div className="secondary mt-1 mb-0 w-3/4">
                                <BodyMedium>
                                    {decodeHtml(document.document_description.replace(/(<([^>]+)>)/gi, ''))}
                                </BodyMedium>
                            </div>
                        )}
                    </div>

                    <div>
                        <ButtonForIcon
                            as="a"
                            href={document.document_file || document.document_url}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {fileExtension && <DownloadIcon />}
                            {!fileExtension && document.document_url && <ExternalLinkIcon />}
                        </ButtonForIcon>
                    </div>
                </div>
            </div>
        </div>
    );
};

DocumentListItem.propTypes = {
    document: PropTypes.shape({
        document_title: PropTypes.string.isRequired,
        document_description: PropTypes.string,
        document_file: PropTypes.string,
        document_url: PropTypes.string,
    }).isRequired,
};

export default DocumentListItem;
